import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import CalendarToday from '@material-ui/icons/CalendarToday';

import { TrashIcon } from '../../../../images/icons/WrapSvg';

class Time extends React.Component {
    state = {
        dow: [],
        apertura: '',
        cierre: '',
        aperturacocina: '',
        cierrecocina: '',
        fechainicio: '',
        fechafin: '',
    };

    static getDerivedStateFromProps(props, state) {
        if (props.info && props.info.id !== state.id) {
            state.id = props.info.id;
            state.dow = props.info && props.info.dow ? props.info.dow : [];
            state.apertura = props.info ? props.info.apertura : '';
            state.cierre = props.info ? props.info.cierre : '';
            state.aperturacocina = props.info ? props.info.aperturacocina : '';
            state.cierrecocina = props.info ? props.info.cierrecocina : '';
            state.fechainicio = props.info ? props.info.fechainicio : '';
            state.fechafin = props.info ? props.info.fechafin : '';
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.props.onChange(event.target.name, event.target.value, this.props.index);
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { intl, index } = this.props;
        const { dow, apertura, aperturacocina, cierre, cierrecocina } = this.state;
        const days = [
            'form_week_day_monday',
            'form_week_day_tuesday',
            'form_week_day_wednesday',
            'form_week_day_thursday',
            'form_week_day_friday',
            'form_week_day_saturday',
            'form_week_day_sunday',
        ];
        const days_values = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
        return (
            <Grid container justify="center" className={'flex_grow_1 shadow_down_only'}>
                <Grid item xs={4} className="">
                    <FormControl fullWidth className="padding_top_18 padding_right_6">
                        <Select
                            multiple
                            name="dow"
                            id="dow"
                            value={dow}
                            onChange={this.handleChange}
                            input={<Input id="select-multiple" />}
                        >
                            {days.map((d, index) => {
                                return (
                                    <MenuItem key={d} value={days_values[index]}>
                                        {intl.formatMessage({ id: d })}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2} className="c_slate_grey upper barlow_regular_small padding_4">
                    <div className="flex_full_row align_center">
                        <CalendarToday className="c_bluish margin_right_6" />
                        <TextField
                            fullWidth
                            name={'apertura'}
                            defaultValue={apertura}
                            onChange={this.handleChange}
                            margin="normal"
                            type="time"
                        />
                    </div>
                </Grid>
                <Grid item xs={2} className="c_slate_grey upper barlow_regular_small padding_4">
                    <TextField
                        fullWidth
                        name={'cierre'}
                        defaultValue={cierre}
                        onChange={this.handleChange}
                        margin="normal"
                        type="time"
                    />
                </Grid>
                <Grid item xs={2} className="c_slate_grey upper barlow_regular_small padding_4">
                    <TextField
                        fullWidth
                        name={'aperturacocina'}
                        defaultValue={aperturacocina}
                        onChange={this.handleChange}
                        margin="normal"
                        type="time"
                    />
                </Grid>
                <Grid item xs={2} className="c_slate_grey upper barlow_regular_small padding_4">
                    <div className="flex_full_row align_center">
                        <TextField
                            fullWidth
                            name={'cierrecocina'}
                            defaultValue={cierrecocina}
                            onChange={this.handleChange}
                            margin="normal"
                            type="time"
                        />
                        <TrashIcon
                            className="margin_left_6 c_lipstick  hand"
                            onClick={(event) => this.props.onDelete(index)}
                        />
                    </div>
                </Grid>
            </Grid>
        );
    }
}

Time.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Time);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/local/Time.js